import { render } from "./OnboardingList.vue?vue&type=template&id=4869ed61&scoped=true"
import script from "./OnboardingList.vue?vue&type=script&lang=js"
export * from "./OnboardingList.vue?vue&type=script&lang=js"

import "./OnboardingList.vue?vue&type=style&index=0&id=4869ed61&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4869ed61"]])

export default __exports__